import topic from '../topic'
export const docuAPI = {
    getDocus: topic.docuTopic + '/get_docus',
    uploadDocuments: topic.docuTopic + '/upload_documents',
    destroyDocuPterById: topic.docuTopic + '/destroy_docu_pter_by_id',
    getFileByUrl: topic.docuTopic + '/get_file_by_url',
}